import { ModelBase, NeoModel, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class CreateClientAccountMappingCommand extends ModelBase {
    public missingAccountId: number | null = null;

    public staticCurrencyId: number = 0;

    public clientNumber: string = "";

    public clientName: string = "";

    public staticServiceProviderFileGroupingId: number | null = null;

    public serviceProviderAccountNumber: string = "";

    public brokerDescription: string = "";

    public activeInactive: string = "";

    public isMappedFromMissingAccounts: boolean = false;

    public clientEntityTypeId: number | null = null;

    public clientEntityTypeName: string | null = null;

    // Client only properties / methods
    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }
}